<button mat-fab [matMenuTriggerFor]="menu" class="mat-elevation-z0 avatar">
  {{this.initials}}
</button>
<mat-menu #menu="matMenu">
  <mat-card appearance="outlined" class="example-card mat-elevation-z0">
    <button mat-fab color="red" class="mat-elevation-z0">
      {{this.initials}}
    </button>
    <h2>{{name}}</h2>
    <mat-chip-listbox class="chip-list">
    </mat-chip-listbox>
    <!-- <mat-card-content>
    <themis-points-view></themis-points-view>
  </mat-card-content> -->
  <mat-card-actions class="card-actions">
    <button (click)="navigateToChangePassword()" mat-stroked-button color="black" class="action-button">
      <mat-icon>lock</mat-icon>
      Change Password
    </button>
    <button (click)="this.logout()" mat-stroked-button color="black" class="action-button logout-button">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  </mat-card-actions>
</mat-card>
</mat-menu>
